import * as React from "react"
import { CloseIcon, KeyboardArrowDownIcon } from "@design/icons/material-symbols"
import { Button } from "@design/ui/button"
import { Field } from "@design/ui/field"
import { Input } from "@design/ui/input"
import { Kbd } from "@design/ui/kbd"
import { Label } from "@design/ui/label"

export interface CustomizeAgentWiring {
  close: React.ComponentProps<typeof CloseIcon>
  customizeAgentSlot?: React.ReactNode
  field?: Omit<React.ComponentProps<typeof Field>, "children">
  fieldShowLabel?: boolean
  label?: Omit<React.ComponentProps<typeof Label>, "children">
  fieldShowDescription?: boolean
  fieldDescription?: string
  fieldSlot?: React.ReactNode
  input?: Omit<React.ComponentProps<typeof Input>, "type" | "placeholder">
  field2?: Omit<React.ComponentProps<typeof Field>, "children">
  fieldShowLabel2?: boolean
  label2?: Omit<React.ComponentProps<typeof Label>, "children">
  fieldShowDescription2?: boolean
  fieldDescription2?: string
  fieldSlot2?: React.ReactNode
  input2?: Omit<React.ComponentProps<typeof Input>, "type" | "placeholder">
  field3?: Omit<React.ComponentProps<typeof Field>, "children">
  fieldShowLabel3?: boolean
  label3?: Omit<React.ComponentProps<typeof Label>, "children">
  fieldShowDescription3?: boolean
  fieldDescription3?: string
  fieldSlot3?: React.ReactNode
  selectShowIcon?: boolean
  selectPlaceholder?: string
  customizeAgentShowFooter?: boolean
  button: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart?: boolean
  buttonLabel?: string
  buttonShowKbd?: boolean
  kbd: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon?: boolean
  kbdLabel?: string
  kbdShowRightIcon?: boolean
  buttonShowIconEnd?: boolean
  button2: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart2?: boolean
  buttonLabel2?: string
  buttonShowKbd2?: boolean
  kbd2: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon2?: boolean
  kbdLabel2?: string
  kbdShowRightIcon2?: boolean
  buttonShowIconEnd2?: boolean
  customizeAgentShowScroller?: boolean
  button3: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  iconCaretDown: React.ComponentProps<typeof KeyboardArrowDownIcon>
}

export const CustomizeAgentContext = React.createContext<CustomizeAgentWiring | null>(null)

export function useWiring(): CustomizeAgentWiring {
  const wiring = React.useContext(CustomizeAgentContext)
  if (wiring === null) {
    throw new Error("CustomizeAgentScreen: render inside <CustomizeAgentContext.Provider>")
  }
  return wiring
}
